import { render, staticRenderFns } from "./VMenuAutocomplete.vue?vue&type=template&id=3145c086"
import script from "./VMenuAutocomplete.vue?vue&type=script&lang=js"
export * from "./VMenuAutocomplete.vue?vue&type=script&lang=js"
import style0 from "./VMenuAutocomplete.vue?vue&type=style&index=0&id=3145c086&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports